// src/components/Toast.jsx
import React from "react";

/**
 * Toast notification — ตาม pattern เดิมใน USAShipmentDatagrid
 * usage: const [toast, setToast] = useState(null);
 *        showToast = (msg, type="success") => { setToast({msg,type}); setTimeout(()=>setToast(null),3500); }
 */
export const Toast = ({ toast }) => {
  if (!toast) return null;
  return (
    <div style={{
      position:     "fixed",
      top:          16,
      right:        16,
      zIndex:       9999,
      background:   toast.type === "error" ? "#fef2f2" : "#f0fdf4",
      color:        toast.type === "error" ? "#dc2626" : "#15803d",
      border:       `1px solid ${toast.type === "error" ? "#fca5a5" : "#86efac"}`,
      borderRadius: 10,
      padding:      "10px 20px",
      fontWeight:   700,
      fontSize:     13,
      boxShadow:    "0 4px 16px #0002",
    }}>
      {toast.msg}
    </div>
  );
};
